import { useUserFeatures } from "../../contexts/UserFeaturesContext";
import { useSubscriptionCards } from "../../contexts/SubscriptionCardsContext";

const useIsSubscriptionManagementEnabled = (): boolean => {
  const features = useUserFeatures();
  const { cards, isLoading } = useSubscriptionCards();

  return Boolean(
    features.cards &&
      features.enable_subscription_management &&
      cards.length > 0 &&
      !isLoading
  );
};

export default useIsSubscriptionManagementEnabled;
